module.exports = __webpack_public_path__ + "img/20190724154011511.6def7aad.png";